module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "toast-wrapper",
    class: {
      'toast-top': _vm.position === 'top', 'toast-center': _vm.position === 'center', 'toast-bottom': _vm.position === 'bottom'
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.tip))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb7f6ad","hasScoped":true}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 482
// module chunks = 0 1 2 3 4 5 6 7 8